module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSAiLi4vaW1hZ2VzL3NsaWNrLnN2ZyI7"